import { FaInstagram, FaYoutube, FaFacebook, FaTwitter } from "react-icons/fa";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Footer = ({ visitorCount }: any) => {
  const socialLinks = [
    {
      name: "Instagram",
      icon: FaInstagram,
      href: "https://www.instagram.com/orangecitysportsshooting/?hl=en",
      color: "hover:text-pink-500",
    },
    {
      name: "YouTube",
      icon: FaYoutube,
      href: "https://www.youtube.com/@anilpande5240/featured",
      color: "hover:text-red-500",
    },
    {
      name: "Facebook",
      icon: FaFacebook,
      href: "#",
      color: "hover:text-blue-500",
    },
    {
      name: "Twitter",
      icon: FaTwitter,
      href: "#",
      color: "hover:text-sky-500",
    },
  ];

  const quickLinks = [
    { label: "Home", id: "home" },
    { label: "Performance Support", id: "performance_support" },
    { label: "Gallery", id: "gallery" },
    { label: "Achievements", id: "achievements" },
    { label: "Our Branches", id: "branches" },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({ top: element.offsetTop - 80, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[var(--gray-950)] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 sm:gap-10 lg:gap-8">
          {/* Club Info - takes more space */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5 sm:gap-3 mb-4 sm:mb-5">
              <img
                src="https://res.cloudinary.com/dbfyzgffj/image/upload/v1758905512/logo_zjf0g4.png"
                alt="OCSSC Logo"
                className="w-9 h-9 sm:w-11 sm:h-11 rounded-full ring-2 ring-orange-400/30"
              />
              <div>
                <h3 className="text-base sm:text-lg font-bold text-white gowun-batang leading-tight">
                  Orange City Sport Shooting Club
                </h3>
                <p className="text-gray-400 text-[10px] sm:text-xs">
                  Excellence in Sport Shooting Since 2014
                </p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-sm">
              We are dedicated to nurturing champions and representing India on
              international platforms. Our club has consistently produced
              national shooting champions under the expert guidance of Coach
              Anil Pande.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex flex-col sm:flex-row sm:items-center text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm gap-1 sm:gap-0">
                <div className="flex items-center">
                  <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center mr-3 flex-shrink-0">
                    <FaPhone className="w-3.5 h-3.5 text-orange-400" />
                  </div>
                  <a href="tel:+919146146368">+91 9146146368</a>
                </div>
                <span className="hidden sm:inline mx-1">,</span>
                <a href="tel:+918805487999" className="sm:ml-1">
                  +91 8805487999
                </a>
              </div>
              <a
                href="mailto:info@orangecityshootingclub.com"
                className="flex items-center text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
              >
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center mr-3 flex-shrink-0">
                  <FaEnvelope className="w-3.5 h-3.5 text-orange-400" />
                </div>
                info@orangecityshootingclub.com
              </a>
              <div className="flex items-center text-gray-400 text-sm">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center mr-3 flex-shrink-0">
                  <FaMapMarkerAlt className="w-3.5 h-3.5 text-orange-400" />
                </div>
                Nagpur, Maharashtra, India
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-3 lg:col-start-7">
            <h4 className="text-sm font-semibold text-white mb-5 uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-orange-500/0 group-hover:bg-orange-400 transition-all duration-200" />
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Success Summary */}
          <div className="lg:col-span-4">
            <h4 className="text-sm font-semibold text-white mb-5 uppercase tracking-wider">
              Our Success
            </h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-orange-500/10 flex items-center justify-center flex-shrink-0">
                  <svg
                    className="w-5 h-5 text-orange-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122z" />
                  </svg>
                </div>
                <div>
                  <div className="font-semibold text-white text-sm">
                    300+ Athletes
                  </div>
                  <div className="text-xs text-gray-500">Active members</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-orange-500/10 flex items-center justify-center flex-shrink-0">
                  <svg
                    className="w-5 h-5 text-orange-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div>
                  <div className="font-semibold text-white text-sm">
                    200+ Players
                  </div>
                  <div className="text-xs text-gray-500">National level</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-orange-500/10 flex items-center justify-center flex-shrink-0">
                  <svg
                    className="w-5 h-5 text-orange-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div>
                  <div className="font-semibold text-white text-sm">
                    10+ Years
                  </div>
                  <div className="text-xs text-gray-500">Of excellence</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Social + Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Social */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center text-gray-400 ${social.color} hover:bg-white/10 transition-all duration-200`}
                    aria-label={social.name}
                  >
                    <Icon size={16} />
                  </a>
                );
              })}
            </div>

            {/* Copyright */}
            <p className="text-gray-500 text-xs text-center">
              &copy; {new Date().getFullYear()} Orange City Sport Shooting Club.
              All rights reserved.
            </p>

            {/* Visitor Count */}
            <div className="text-gray-500 text-xs">
              Visitors: {visitorCount?.toLocaleString() || "—"} V.1.0.0
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
